/**
 * @public
 */
export enum ECommItemType {
    PRODUCT = 'product',
    EVENT = 'event',
}

/**
 * Returns the tracked event namespace for the provided {@link ECommItemType}.
 *
 * @internal
 */
export function getTrackableKey(key: ECommItemType) {
    switch (key) {
        case ECommItemType.PRODUCT:
            return 'products' as const
        case ECommItemType.EVENT:
            return 'events' as const
        default:
            return 'unknown' as const
    }
}
